const navigationFunctions = () => {
    $(document).on('click', '.js-hamburger', function(e) {
        e.preventDefault();

        $(this).stop().toggleClass('open');
        $('.c-nav').stop().toggleClass('c-nav--is-open');
		$('body').stop().toggleClass('nav-open');
    });

    $(document).on('click', '.js-toggle-child-menu', function(e) {
        e.preventDefault();

        $(this).stop().toggleClass('open');
        $(this).next('.sub-menu').stop().slideToggle();
    });
};
